import Logo from "../../assets/logo.svg";

export const logo = {
  width: 220,
  topBarSource: Logo,
  url: "https://portal.accountswitcher.app",
  accessibilityLabel: "Account Switcher",
};
